const ROUTER_HELPERS = {
  error: (status: number) => `/${status}`,
}

export const STUDENT_SITE_URL = import.meta.env.VITE_STUDENT_SITE_URL

const BASE_PATHS = {
  USER: '/user',
  QUESTION: '/question',
  MODULE: '/module/',
  CLASS: '/class',
  PRACTICE_TEST: '/practice-test',
  ATTEMPT: '/attempt',
}

export const ENDPOINTS = {
  SIGN_IN: `${BASE_PATHS.USER}/login`,
  GET_QUESTIONS_BY_MODULE: `${BASE_PATHS.QUESTION}/module`,
  GET_MODULES: `${BASE_PATHS.MODULE}`,
  GET_CLASS_BY_MODULE: `${BASE_PATHS.CLASS}/with-counts`,
  INIT_ATTEMPT: `${BASE_PATHS.ATTEMPT}/init`,
  UPDATE_ATTEMPT: `${BASE_PATHS.ATTEMPT}/update`,
  GET_CONFIG: `${BASE_PATHS.MODULE}config/`,
  GET_ME: `${BASE_PATHS.USER}/me`,
  REFRESH_TOKEN: `${BASE_PATHS.USER}/refresh`,
  GET_QUESTIONS_BY_ID: (id: number) => `${BASE_PATHS.QUESTION}/${id}`,
  GET_CLASS_BY_ID: (classId: number) => `${BASE_PATHS.CLASS}/${classId}`,
  GET_ALL_EXAMS_BY_CLASS_ID: (classId: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${classId}/students`,
  GET_EXAM_READ_TIME: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/read`,
  START_READ_EXAM: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/start-read`,
  GET_ATTEMPT_DETAIL: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/checkpoint`,
  GET_ATTEMPT_SHEET: (className: string, testName: string, fullName: string) =>
    `${BASE_PATHS.ATTEMPT}/auth/get_sheetlink?class_name=${className}&test_name=${testName}&full_name=${fullName}`,

  GET_CLASS_STATISTICS: (classId: number) =>
    `${BASE_PATHS.CLASS}/${classId}/statistics`,
}

export enum TypeVlueExam {
  MOCK_TEST = 'MOCK_EXAM',
  PRACTICE_TEST = 'PRACTICE_TEST',
}
export enum ExamType {
  ME = 'Mock exam',
  PT = 'Preset Practice Test',
  // MPT = "My Practice Test",
}

export const STATUS_REDIRECTS: Record<number, string> = {
  401: ROUTER_HELPERS.error(401),
  403: ROUTER_HELPERS.error(403),
  404: ROUTER_HELPERS.error(404),
  500: ROUTER_HELPERS.error(500),
  503: ROUTER_HELPERS.error(503),
}

export const STATUS_MESSAGES: Record<number, string> = {
  401: 'Your session has expired. Please sign in again.',
  403: 'You do not have permission to access this resource.',
  404: 'Resource not found.',
  500: 'Internal Server Error!',
  503: 'Server is under maintenance. Please try again later.',
}
